import { Skeleton } from "@mui/material";
import { useState, useEffect } from "react";
import {
  WhyChooseWrapper,
  WhyChooseGrid,
  WhyChooseTextSection,
  WhyChooseTitle,
  WhyChooseDescription,
  WhyChooseImageSection,
  WhyChooseCardsTop,
  WhyChooseCardsBottom,
  WhyChooseCard,
  WhyChooseCardContent,
  WhyChooseCardIcon,
  WhyChooseCardTitle,
  WhyChooseCardDescription,
} from './styles/components';
import { Box } from '@mui/material';

export default function WhyChooseSection() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const infoItems = [
    {
      title: "Fixed Rates",
      description: "Enjoy price stability for the duration of your plan terms",
      icon: "/images/constenewImg/App.svg",
    },
    {
      title: "Bill Credits",
      description: "Earn up to $50 back on your monthly bill",
      icon: "/images/constenewImg/App-1.svg",
    },
    {
      title: "Easy Setup",
      description: "Enroll online or over the phone in 5 minutes",
      icon: "/images/constenewImg/App-2.svg",
    },
    {
      title: "ETF Coverage",
      description: "We will cover your early termination fee up to $150",
      icon: "/images/constenewImg/App-3.svg",
    },
  ];

  return (
    <WhyChooseWrapper>
      {loading ? (
        <Box sx={{ 
          display: "flex",
          flexDirection: "column",
          gap: { xs: "24px", md: "32px" },
          maxWidth: "1200px",
          width: "100%",
        }}>
          <Box sx={{ 
            display: "flex",
            flexDirection: "column",
            gap: '24px',
          }}>
            <Skeleton variant="text" width="60%" height={70} />
            <Skeleton variant="text" width="80%" height={50} />
          </Box>
          <Box sx={{ 
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
            gap: '32px',
          }}>
            <Skeleton variant="rounded" width="100%" height={326} sx={{ borderRadius: '16px' }} />
            <Box sx={{ 
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: '32px',
            }}>
              {[1, 2, 3, 4].map((idx) => (
                <Skeleton 
                  key={idx} 
                  variant="rounded" 
                  width="100%" 
                  height={150} 
                  sx={{ borderRadius: '8px' }} 
                />
              ))}
            </Box>
          </Box>
        </Box>
      ) : (
        <WhyChooseGrid>
          <WhyChooseTextSection>
            <WhyChooseTitle>
              Why choose Constellation?
            </WhyChooseTitle>
            <WhyChooseDescription>
              From stable rates to easy enrollment, Constellation makes managing your home energy simple, affordable,
              and reliable.
            </WhyChooseDescription>
          </WhyChooseTextSection>

          <WhyChooseImageSection />

          <WhyChooseCardsTop>
            {infoItems.slice(0, 2).map((item, index) => (
              <WhyChooseCard key={`top-${index}`}>
                <WhyChooseCardContent>
                  <WhyChooseCardIcon
                    src={item.icon}
                    alt={item.title}
                  />
                  <WhyChooseCardTitle>
                    {item.title}
                  </WhyChooseCardTitle>
                </WhyChooseCardContent>
                <WhyChooseCardDescription>
                  {item.description}
                </WhyChooseCardDescription>
              </WhyChooseCard>
            ))}
          </WhyChooseCardsTop>

          <WhyChooseCardsBottom>
            {infoItems.slice(2, 4).map((item, index) => (
              <WhyChooseCard key={`bottom-${index}`}>
                <WhyChooseCardContent>
                  <WhyChooseCardIcon
                    src={item.icon}
                    alt={item.title}
                  />
                  <WhyChooseCardTitle>
                    {item.title}
                  </WhyChooseCardTitle>
                </WhyChooseCardContent>
                <WhyChooseCardDescription>
                  {item.description}
                </WhyChooseCardDescription>
              </WhyChooseCard>
            ))}
          </WhyChooseCardsBottom>
        </WhyChooseGrid>
      )}
    </WhyChooseWrapper>
  );
}
